import { spec, validators } from 'utils/validation'
import { combine } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'

import ResetFormComponent from './component'

const { any, string } = validators

export const ResetForm = combine(
  withFormModel(
    {
      email: spec.flow(
        string.isString,
        string.isNotEmpty,
        string.isEmail,
        any.required
      ),
    },
    { id: 'reset-form' }
  )
)(ResetFormComponent)
